module.exports = __webpack_public_path__ + "img/3-8572.13572044.png";